export default {
    update: "Update",
    title: "Updates",
    columns: {
        name: "Service name",
        version: "Version",
        download: "Download Date",
    },
    notification: {
        load_error: "Load error",
        download_ok: "Request send",
        download_error: "Request error",
    },
}